import PageLayout from "../../../../../components/page/PageLayout";
import PaymentHistoryLayout from "../../../account/layout/payments/PaymentHistoryLayout";

const PagePayment = () => {

    return (
        <PageLayout requireSignIn>
            <PaymentHistoryLayout />
        </PageLayout>
    )
}

export default PagePayment;
